import { Component, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-tags-input',
  templateUrl: './tags-input.component.html',
  styleUrls: ['./tags-input.component.css']
})

export class TagsInputComponent {
  @Output() onTagsUpdate: EventEmitter<Array<string>> = new EventEmitter();
  tag: string;

  tags: Array<string> = new Array<string>();

  constructor() { }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
    this.onTagsUpdate.emit(this.tags);
  }

  addTag(form: NgForm, keyCode: number): void {
    if (form.value.tag) {
      if (keyCode == 13) {
        this.tags.push(form.value.tag);
        this.onTagsUpdate.emit(this.tags);
        form.reset();
      }
    }
  }

}
